
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export function toUtcDate(input?: string): dayjs.Dayjs | null {
  if (!input) {
    return null;
  }
  const parsed = dayjs(input);
  return parsed.isValid() ? parsed.utc() : null;
}